/** Dashboard filters put candidate email, phone and name in the query string. */
export const stripQuery = (url) => {
    if (!url) {
        return '';
    }
    const cut = url.search(/[#?]/u);
    return cut === -1 ? url : url.slice(0, cut);
};
// Fixed width, so a replay does not reveal the length of a name or number.
const MASK = '***';
const maskInput = (text) => (text.trim() ? MASK : text);
/**
 * Replays show text under the `data-ph-unmask` app root unless a nearer
 * `data-ph-mask` hides it. Mark anything that renders data about a person, a
 * candidate or a secret. Portals (MUI tooltips, menus, dialogs) render outside
 * the root, so they stay masked.
 */
const maskText = (text, element) => element
    ?.closest('[data-ph-mask], [data-ph-unmask]')
    ?.hasAttribute('data-ph-unmask')
    ? text
    : maskInput(text);
const URL_ATTRIBUTES = new Set([
    'action',
    'href',
    'poster',
    'src',
    'srcset',
    'xlink:href'
]);
// `download` carries the saved file name, which can include a candidate's name.
const TEXT_ATTRIBUTES = new Set([
    'alt',
    'aria-description',
    'aria-label',
    'aria-valuetext',
    'content',
    'download',
    'label',
    'placeholder',
    'title',
    'value'
]);
// `style` passes through, so a `url(...)` with a signed image URL would be recorded.
export const maskAttribute = (name, value) => {
    const key = name.toLowerCase();
    if (URL_ATTRIBUTES.has(key)) {
        return stripQuery(value);
    }
    if (TEXT_ATTRIBUTES.has(key) || key.startsWith('data-')) {
        return MASK;
    }
    return value;
};
// Replay also routes its page URLs (Meta, `$pageview`, `$url_changed`) through here.
export const maskNetworkRequest = (request) => ({
    ...request,
    name: stripQuery(request.name),
    requestHeaders: undefined,
    requestBody: undefined,
    responseHeaders: undefined,
    responseBody: undefined
});
/** Unset or out of range yields `undefined`, so the project setting applies. */
export const toSampleRate = (value) => {
    const rate = Number(value);
    return value && rate >= 0 && rate <= 1 ? rate : undefined;
};
/**
 * Reviewer screens show ID documents, selfies and candidate PII, so replay
 * blocks media and masks inputs and marked text. Set in code because it
 * outranks the project settings.
 */
export const sessionRecordingOptions = {
    maskAllInputs: true,
    maskInputFn: maskInput,
    // Every text node goes through maskTextFn, which checks for `data-ph-mask`.
    maskTextSelector: '*',
    maskTextFn: maskText,
    // `hidden` and `file` inputs escape `maskAllInputs`.
    blockSelector: 'img, picture, video, canvas, iframe, object, embed, svg image, input[type="hidden"], input[type="file"]',
    maskAttributeFn: maskAttribute,
    maskCapturedNetworkRequestFn: maskNetworkRequest,
    recordHeaders: false,
    recordBody: false,
    captureCanvas: { recordCanvas: false },
    captureJsonLd: false,
    recordCrossOriginIframes: false
};
